export function formatDoc(doc) {
    if(doc.length === 14) { 
        return `${doc.substring(0,2)}.${doc.substring(2,5)}.${doc.substring(5,8)}/${doc.substring(8,12)}-${doc.substring(12,14)}`
    } else if(doc.length === 11) {
        return `${doc.substring(0,3)}.${doc.substring(3,6)}.${doc.substring(6,9)}-${doc.substring(9,11)}`
    } else {
        return "Valor inválido"
    }
}

export function formatPhoneNumber(number) {
    if(number.length === 11) { 
        return `(${number.substring(0,2)}) ${number.substring(2,7)}-${number.substring(7,11)}`
    } 
    return number
}


// WEBPACK FOOTER //
// ./src/components/theme/utils/index.jsx